import r2wc from "@r2wc/react-to-web-component";
import { DayscheduleWidget } from "./widget";
import { initPopupWidget } from "./popup";

const dsWidget = r2wc(DayscheduleWidget, {
  props: {
    url: "string",
    options: "string",
  },
});

customElements.define("dayschedule-widget", dsWidget);

// Attach popup API globally
declare global {
  interface Window {
    daySchedule: {
      initPopupWidget: typeof initPopupWidget;
    };
  }
}

window.daySchedule = {
  initPopupWidget,
};
